import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { Outlet } from 'react-router-dom'
import { ConstantsRoute } from '@/routes/admin/housekeeping/pages/Constants.route'

export const HousekeepingRoute: TileRoleRoute = {
  path: 'housekeeping',
  text: 'Housekeeping',
  element: (
    <>
      <Outlet />
    </>
  ),
  mainMenuRoute: false,
  allowedRoles: [Roles.GlobalAdministrator],
  tile: true,
  children: [ConstantsRoute],
}
